import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";

export default function ThankYou() {
  const [params] = useSearchParams();
  const orderNumber = params.get("order");

  return (
    <div className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="thank-you-page">
      <p className="eyebrow text-silea-navy/60">Дякуємо</p>
      <h1 className="font-serif-display text-5xl sm:text-6xl mt-4 text-silea-navy leading-tight">
        Ваше замовлення<br /><span className="italic">прийнято.</span>
      </h1>
      <p className="mt-6 text-silea-navy/70">
        Номер замовлення:&nbsp;
        <span className="text-silea-navy font-medium" data-testid="order-number">{orderNumber}</span>
      </p>
      <p className="mt-2 text-silea-navy/60 text-sm">
        Наш менеджер зв'яжеться з вами найближчим часом для підтвердження та оплати за реквізитами.
      </p>
      <Button asChild className="mt-10 bg-silea-navy hover:bg-silea-navy/90 text-white rounded-none">
        <Link to="/products" data-testid="continue-shopping">Повернутись до колекції</Link>
      </Button>
    </div>
  );
}
